'use client'

import React from 'react'

interface WizardProgressProps {
  currentStep: number
  totalSteps: number
}

export const WizardProgress: React.FC<WizardProgressProps> = ({
  currentStep,
  totalSteps,
}) => {
  const safeTotal = Math.max(totalSteps, 2)
  const progress = ((currentStep - 1) / (safeTotal - 1)) * 100

  return (
    <div className="w-full mb-6">
      <div className="w-full bg-gray-200 rounded-full h-2 overflow-hidden">
        <div
          className="bg-gradient-to-r from-blue-500 to-blue-600 h-2 rounded-full transition-all duration-500 ease-out"
          style={{ width: `${progress}%` }}
        />
      </div>
    </div>
  )
}
